import { useEffect } from "react";

import { PREVIOUS_PATH } from "~/constants/local-storage";
import { RouteBase } from "~/constants/request";

import { useLocalStorage } from "../use-local-storage/hook";

export const useInitialScrollTop = (ignoreRoutes: RouteBase[] = []): void => {
  const [previousPathRaw] = useLocalStorage(PREVIOUS_PATH, ",", (value) => value);
  const previousPath = previousPathRaw?.split(",")?.[1] ?? "";

  useEffect(() => {
    const notMatched = ignoreRoutes.every((route) => !previousPath.includes(route));
    if (notMatched) {
      // eslint-disable-next-line no-restricted-globals
      window?.scroll({
        top: 0,
        left: 0,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
